export class PartsHttp {
    /**
     * Get parts
     * @returns {Promise<void>}
     */
    static async getAllParts() {
        try {
            return await window.axios.get(`parts`).then(result => result.data);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Updates a part
     * @param id
     * @param part
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async updatePart(id, part) {
        try {
            return await window.axios.put(`parts/${id}`, part).then(result => result.data);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Delete a part
     * @param id
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async deletePart(id) {
        try {
            return await window.axios.delete(`parts/${id}`).then(result => result.data);
        } catch (e) {
            return await Promise.reject(e);
        }
    }
}
